import { Preferences } from "@capacitor/preferences";
import type { StateStorage } from "zustand/middleware";

/**
 * Zustand-compatible storage backed by Capacitor Preferences.
 *
 * On native (Android / iOS) this writes to the platform's secure key/value
 * store. On web, the Capacitor Preferences shim falls back to localStorage,
 * so one adapter handles both surfaces.
 */
export const capacitorPreferencesStorage: StateStorage = {
  getItem: async (name) => {
    const { value } = await Preferences.get({ key: name });
    return value ?? null;
  },
  setItem: async (name, value) => {
    await Preferences.set({ key: name, value });
  },
  removeItem: async (name) => {
    await Preferences.remove({ key: name });
  },
};
